export * from './post-objekt.component';
export * from './post-objekt.component.module';